import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "svg-icon svg-icon-1 position-absolute ms-6 my-3" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "svg-icon svg-icon-1 position-absolute ms-6 my-3" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search fs-4 me-2" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "col"
}
const _hoisted_12 = {
  href: "#",
  class: "btn btn-info me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_sub_agent"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus fs-4 me-2" }, null, -1)
const _hoisted_14 = { class: "row pt-4" }
const _hoisted_15 = { class: "col-lg-3 col-xl-3 col-md-4 col-12" }
const _hoisted_16 = { class: "col-lg-9 col-xl-9 col-md-8 col-12" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-body pt-0" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "text-success"
}
const _hoisted_21 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  key: 0,
  class: "badge bg-primary"
}
const _hoisted_24 = {
  key: 1,
  class: "badge bg-secondary"
}
const _hoisted_25 = {
  key: 2,
  class: "badge bg-danger"
}
const _hoisted_26 = {
  key: 0,
  class: "badge bg-primary"
}
const _hoisted_27 = {
  key: 1,
  class: "badge bg-warning"
}
const _hoisted_28 = {
  key: 2,
  class: "badge bg-success"
}
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "mr-4" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_SubAgentTree = _resolveComponent("SubAgentTree")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_NewSubAgent = _resolveComponent("NewSubAgent")!
  const _component_UpdateSubAgent = _resolveComponent("UpdateSubAgent")!
  const _component_UpdateRollRate = _resolveComponent("UpdateRollRate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.search.name = $event)),
          class: "form-control form-control-solid w-250px ps-15",
          placeholder: _ctx.$t('Agents.Name')
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.search.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search.code = $event)),
          class: "form-control form-control-solid w-250px ps-15",
          placeholder: _ctx.$t('Agents.Code')
        }, null, 8, _hoisted_7), [
          [_vModelText, _ctx.search.code]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_DateRangePicker, { onChangedate: _ctx.setSelectedDate }, null, 8, ["onChangedate"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getSubAgents(_ctx.tempAgentSearch, _ctx.tempLevelSearch)))
        }, [
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("MoneyTransfer.Search")), 1)
        ])
      ]),
      (_ctx.$store.state.AuthModule.user.level === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("a", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(_toDisplayString(_ctx.$t("Agents.NewSubAgent")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_SubAgentTree, { onGetSubAgents: _ctx.getSubAgents }, null, 8, ["onGetSubAgents"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": true,
              rowsPerPage: 50
            }, {
              "cell-name": _withCtx(({ row: agent }) => [
                _createElementVNode("a", {
                  href: "#",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_upd_agent",
                  onClick: ($event: any) => (_ctx.setAgent(agent))
                }, [
                  _createElementVNode("span", null, _toDisplayString(`${agent.name} (${agent.code})`), 1)
                ], 8, _hoisted_19)
              ]),
              "cell-al_balance": _withCtx(({ row: agent }) => [
                (Number(agent.al_balance) > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$n(Number(agent.al_balance))), 1))
                  : (Number(agent.al_balance) < 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$n(Number(agent.al_balance))), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$n(Number(agent.al_balance))), 1))
              ]),
              "cell-status": _withCtx(({ row: agent }) => [
                (agent.status === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t("Agents.Normal")), 1))
                  : (agent.status === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t("Agents.Stopped")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("Agents.Suspended")), 1))
              ]),
              "cell-level": _withCtx(({ row: agent }) => [
                (Number(agent.level) === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("Agents.Level") + " " + agent.level), 1))
                  : (Number(agent.level) === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t("Agents.Level") + " " + agent.level), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t("Agents.Level") + " " + agent.level), 1))
              ]),
              "cell-action": _withCtx(({ row: agent }) => [
                (_ctx.$store.state.AuthModule.user.id !== agent.id)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { path: `/agents/al/deposits/history/${agent.id}` },
                      class: "btn btn-sm btn-secondary btn-hover-rise me-5"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Menu.AlAddHistory")), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.AuthModule.user.id !== agent.id)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: { path: `/agents/al/history/${agent.id}` },
                      class: "btn btn-sm btn-primary btn-hover-rise me-5"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Menu.AlHistory")), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_29))
              ]),
              "cell-roll_pct": _withCtx(({ row: agent }) => [
                _createElementVNode("span", _hoisted_30, _toDisplayString(agent.roll_pct + "%"), 1),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-info btn-sm me-3",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_upd_agent_roll",
                  onClick: ($event: any) => (_ctx.setAgent(agent))
                }, _hoisted_33, 8, _hoisted_31)
              ]),
              "cell-rolling": _withCtx(({ row: agent }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$n(
                    _ctx.getComputedToday(
                      Number(agent.betamount),
                      Number(agent.today_betamount)
                    )
                  )), 1)
              ]),
              "cell-winamount": _withCtx(({ row: agent }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$n(
                    _ctx.getComputedToday(
                      Number(agent.winamount),
                      Number(agent.today_winamount)
                    )
                  )), 1)
              ]),
              "cell-profit": _withCtx(({ row: agent }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$n(
                    _ctx.getComputedToday(
                      Number(agent.betamount),
                      Number(agent.today_betamount)
                    ) -
                      _ctx.getComputedToday(
                        Number(agent.winamount),
                        Number(agent.today_winamount)
                      )
                  )), 1)
              ]),
              "cell-rollingprofit": _withCtx(({ row: agent }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$n(
                    _ctx.getComputedToday(
                      Number(agent.betamount),
                      Number(agent.today_betamount)
                    ) *
                      (agent.roll_pct / 100)
                  )), 1)
              ]),
              "cell-finalprofit": _withCtx(({ row: agent }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$n(
                    _ctx.getComputedToday(
                      Number(agent.betamount),
                      Number(agent.today_betamount)
                    ) -
                      _ctx.getComputedToday(
                        Number(agent.winamount),
                        Number(agent.today_winamount)
                      ) -
                      _ctx.getComputedToday(
                        Number(agent.betamount),
                        Number(agent.today_betamount)
                      ) *
                        (agent.roll_pct / 100)
                  )), 1)
              ]),
              _: 1
            }, 8, ["table-data", "table-header"])
          ])
        ])
      ]),
      _createVNode(_component_NewSubAgent, { onRefresh: _ctx.getSubAgents }, null, 8, ["onRefresh"]),
      _createVNode(_component_UpdateSubAgent, {
        onRefresh: _ctx.getSubAgents,
        agent: _ctx.selectedAgent
      }, null, 8, ["onRefresh", "agent"]),
      (_ctx.selectedAgent)
        ? (_openBlock(), _createBlock(_component_UpdateRollRate, {
            key: 0,
            onRefresh: _ctx.getSubAgents,
            agent: _ctx.selectedAgent
          }, null, 8, ["onRefresh", "agent"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}